angular.module('impactx.purchaseorder').directive('ixSapOrderInfo', function () {
    return {
        scope: {
            cardTitle: '@',
            sapData: '='
        },
        restrict: 'E',
        templateUrl: 'modules/purchaseorder/templates/saporderinfo.tmpl.html'
    };
});